import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              影视分类
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              按类型浏览，快速找到你想看的影视资源
            </p>
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-50 hover:bg-primary-50 transition-all duration-300 group cursor-pointer"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${cat.icon} text-lg md:text-xl`} />
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-[10px] md:text-xs text-foreground-400">
                  {cat.count}部
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}